import Utils from '../Utility/Utility';

function send_pa_ga_event(e){
    var data = {
        'ge_action': 'Click',
        'ge_category': 'Public Affairs Key Issues Right Column Widget',
        'ge_label': e.target.href,
        'ge_noninteraction' : false
    }
    // console.log(e.target.href)
    send_ga_event(data)
}

function PublicAffairsRightColumnWidget_init(){

    var widgetName          = "Public Affair Issues";
    var widgetSelector      = '[data-widget-title="'+widgetName+'"]';
    var widgetHeader        = '.rec-widget-header';
    var widgetBodySelector  = '.rec-link-body';

    // If widget selector already on page trigger the pa widget on file load
    if($(widgetSelector).length > 0){
        // console.log("WIDGET SELECTOR FOUND, CONTINUING WITH PA WIDGET PLACEMENT");
        triggerCustomPaWidget();

        // else listen for the event
    }else{

        document.addEventListener('public_affair_issues_widget_ready', function(e){
            // console.log("GOT EVENT public_affair_issues_widget_ready", e);
            triggerCustomPaWidget();
        });
    }

    function triggerCustomPaWidget(){

        var $widgetDiv = $(widgetSelector);

        if(!$widgetDiv){
            return;
        }

        $widgetDiv.hide();

        var file = "https://www.realclearpublicaffairs.com/public_affairs/"+Utils.make_slug(SITE_NAME)+"_homepage_right_column_hp_widget_callback.jsonp?callback=?";
        // console.log(file);

        $.ajax({
            crossDomain: true,
            url: file,
            dataType: 'jsonp',
            jsonp: 'callback',
            jsonpCallback: 'callback',
            success : function(res) {

                // console.log("SUCCESS GOT widgetdata", res);
                var day_num         = Math.floor(((Date.now() / 1000 / 60 / 60) + 11.5) / 24);
                var num_per_load    = parseInt(res.max_issues_visible);
                var offset          = parseInt(res.widget_offset);
                var items           = res.pub_issues;
                var total           = items.length;
                var baseUrl         = 'https://www.realclearpublicaffairs.com/public_affairs/';
                var header          = '';
                var html            = '';

                html += '<ul class="">';
                for(var i = 0; i < total; i++) {

                    /* Use modulus to determine cycle between total available, 
                       set by day num and offset, within range specified by num-per-load */
                    var this_order = (day_num + offset + i) % total;     // Uncomment line to restore rotation
                    // var this_order = i;                                     // Delete line to restore rotation
                    if( i < num_per_load ) {
                        var issue = items[this_order];
                        var campaign_qs = '?utm_campaign=public_affairs_widget&utm_medium='+Utils.make_slug(SITE_NAME)+'&utm_source=homepage_right_column';
                        var issueUrl = baseUrl+issue.slug + '/' + campaign_qs;

                        if(issue.image !== null && header.length == 0){

                            var issueImage = issue.image.resized_images_loc.replace('_1_', '_4_');
                            // header
                            header = '<div class="rec-image">'+
                                '<a class="pa-widget-anchors" href="'+issueUrl+'" style="background: url('+issueImage+');background-size:cover;display:block; height:100%;">'+
                                '</a>'+
                                '</div>';

                        }

                        html += '<li class="">'+
                            '<div class="content_wrapper">'+
                            '<div class="title">'+
                            '<a class="pa-widget-anchors" href="'+issueUrl+'">'+issue.name+'</a>'+
                            '</div>'+
                            '</div>'+
                            '</li>';
                    }

                    // console.log(day_num+' '+offset+' '+i+' '+this_order);
                }

                html += '</ul>';
                $(widgetHeader, widgetSelector).html('' +
                    '<div class="rec-title" style="color:#ffffff; !important; ">Key Issues</div>' +
                    '<div class="pa-widget-logo">' +
                    '   <a href="https://www.realclearpublicaffairs.com">' +
                    '       <img src="/asset/img/rcpa-home-logo.png" alt="Real Clear Public Affairs Logo">' +
                    '   </a>' +
                    '</div>');
                $(widgetBodySelector, widgetSelector).html(header+html);
                $widgetDiv.addClass('pa-rc-widget');
                $widgetDiv.show();
                $('.pa-widget-anchors').on('click', function(e){
                    send_pa_ga_event(e);
                })
            },
        });
    }
}

export default PublicAffairsRightColumnWidget_init;